/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { Grid } from '../../../design-system/layout/Grid';
import { StatTile } from '../../../design-system/molecules/StatTile/StatTile';
import type { StatTileTone } from '../../../design-system/molecules/StatTile/StatTile';

export interface PipelineKpi {
  label: ReactNode;
  value: ReactNode;
  caption?: ReactNode;
  tone?: StatTileTone;
}

export interface PipelineKpiRowProps {
  items: PipelineKpi[];
}

/** 파이프라인 KPI 줄. 모듈 수·진행 중·실패(24h) 운영 상태 요약에 활용. */
export function PipelineKpiRow({ items }: PipelineKpiRowProps) {
  return (
    <Grid cols={items.length} gap="md">
      {items.map((kpi, i) => (
        <StatTile key={i} label={kpi.label} value={kpi.value} caption={kpi.caption} tone={kpi.tone} />
      ))}
    </Grid>
  );
}
